import { render, staticRenderFns } from "./TutorialMessages.vue?vue&type=template&id=a85cfe2e&scoped=true&"
import script from "./TutorialMessages.vue?vue&type=script&lang=js&"
export * from "./TutorialMessages.vue?vue&type=script&lang=js&"
import style0 from "./TutorialMessages.vue?vue&type=style&index=0&id=a85cfe2e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85cfe2e",
  null
  
)

export default component.exports